import React, { useState, useEffect, useContext, useRef } from "react";
import AircallPhone from "aircall-everywhere";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { Animation } from "../../../../../components";
import { ToastContainer } from "react-toastify";

import { createPhoneActivity } from "../../../../../services/api/organization.api";

function Aircall({ phones, leadId }) {
  const [numbersToggle, setNumbersToggle] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState("");

  const aircallPhone = useRef(
    new AircallPhone({
      onLogin: () => {
        if (phones && phones[0] && aircallPhone && aircallPhone.current) {
          aircallPhone.current.send(
            "dial_number",
            { phone_number: phones[0] },
            (success, data) => {}
          );
          setSelectedNumber(phones[0]);
        }
      },
      domToLoadPhone: "#phone",
      size: "big",
    })
  );

  const dial = (number) => {
    aircallPhone.current &&
      aircallPhone.current.send(
        "dial_number",
        { phone_number: number },
        (success, data) => {}
      );
  };

  useEffect(() => {
    if (aircallPhone && aircallPhone.current) {
      aircallPhone.current.on("outgoing_call", async (data) => {
        await createPhoneActivity({
          leadId,
          template: "leadCalled",
          data: {
            callId: data.call_id,
            from: data.from,
            to: data.to,
            answered: false,
          },
          clientDate: Date.now(),
        });
      });

      aircallPhone.current.on("call_ended", async (data) => {
        if (data.duration !== "00:00") {
          await createPhoneActivity({
            leadId,
            template: "leadCallEnded",
            data: {
              callId: data.call_id,
              from: data.from,
              to: data.to,
              answered: true,
              duration: data.duration,
            },
            clientDate: Date.now(),
          });
        }
      });
    }
    return () => {
      if (aircallPhone && aircallPhone.current) {
        aircallPhone.current.removeListener("outgoing_call");
        aircallPhone.current.removeListener("outgoing_answered");
        aircallPhone.current.removeListener("call_ended");
        aircallPhone.current = null;
      }
    };
  }, []);

  return (
    <>
      <div>
        <div
          className="cstm-dropdown add-to-list "
          style={{ paddingBottom: "10px" }}
        >
          <div className={"custom-title"}>
            <FormattedMessage id={"leads.properties.phones"} />
          </div>
          <div className="dropdown">
            <button
              className="dropdown-toggle select-button "
              onClick={() => setNumbersToggle(!numbersToggle)}
              style={{ minWidth: "max-content", height: 36, fontSize: 14 }}
            >
              <p style={{ width: "max-content", fontSize: 14 }}>
                {selectedNumber ? selectedNumber : phones && phones[0]}{" "}
              </p>
            </button>
            <Animation.SlideDown
              className={"dropdown-menu show"}
              toggle={numbersToggle}
              setToggle={setNumbersToggle}
            >
              <ul>
                {phones.map((number, i) => (
                  <li
                    key={i}
                    onClick={() => {
                      setSelectedNumber(number);
                      dial(number);
                      setNumbersToggle(false);
                    }}
                  >
                    <a
                      href="#"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        margin: "1s0px 0",
                      }}
                    >
                      <span className="name_ui">{number}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </Animation.SlideDown>
          </div>
        </div>
        <ToastContainer position="bottom-right" style={{ top: 100 }} />
      </div>

      <iframe
        allow="microphone; autoplay; clipboard-read; clipboard-write; hid"
        src="https://phone.aircall.io?integration=generic"
        style={{
          height: "540px",
          width: "370px",
          borderColor: "rgba(0,179,136,0.3)",
          borderRadius: "10px",
          transform: "scale(.9)",
        }}
      ></iframe>
    </>
  );
}

export default Aircall;
